import { useQuery } from "react-query";
import { calculateAge } from "../../../../utilis/methods/dateMethods";
import { getPatientGroupingDisplay } from "../../../../utilis/methods/patientGrouping";
import { PatientData } from "./types";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { getVisitType } from "../../../../EMR/services";
// import useAuthentication from "@hooks/useAuthentication";

const PatientDetails = ({ Patientdata }: { Patientdata: PatientData }) => {
  const handleDisplayAge = (dob: string) => {
    const ageData = calculateAge(dob);
    return `${ageData.age} ${ageData.ageType}`;
  };

  const { data: visitType } = useQuery(
    ["visitTypeInPatinetDetails"],
    getVisitType,
  );

  const displayVisitType = (id: number) => {
    if (visitType?.response.length) {
      const res = visitType?.response?.find((i) => i.id == id)?.visitType || "";
      return res;
    } else {
      return "";
    }
  };
  // const { user } = useAuthentication();
  // const regionValue = user?.region;
  // const idHeading = regionValue === "QATAR_REGION" ? "Qatar ID" : "Emirates Id";
  const idHeading = "Civil ID"
  return (
    <div className="max-w-4xl mx-auto p-3 shadow-lg rounded-lg">
      {/* Basic Details Section */}
      <div className="mb-4">
        <div className="py-2 px-3">
          <Typography fontSize={"1rem"} fontWeight={600} color={"primary"}>
            Basic detail
          </Typography>
        </div>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: 0 }}>
                <strong>Patient Name</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.patient?.patientName}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>Mobile No</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.contact?.contact || ""}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>Age</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {handleDisplayAge(Patientdata?.patient?.dateOfBirth) || ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 0 }}>
                <strong>Gender</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.patient?.gender || ""}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>
                  {Patientdata?.patient?.emiratesId && idHeading}
                  {Patientdata?.patient?.gccId && "GCC ID"}
                  {Patientdata?.patient?.passportNum && "Passport No"}
                </strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                :{" "}
                {Patientdata?.patient?.emiratesId ||
                  Patientdata?.patient?.gccId ||
                  Patientdata?.patient?.passportNum ||
                  ""}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>Address</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }} width={250}>
                :{" "}
                {Patientdata?.contact?.address1 ||
                  Patientdata?.contact?.address2 ||
                  ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 0 }}>
                <strong>Visit Type</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {displayVisitType(Patientdata?.patient?.visitType) || ""}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>Country</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.contact?.country || ""}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>EMR No/Reg No</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.patient?.emrNo || ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 0 }}>
                <strong>Department</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.doctor?.department || ""}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>Doctor</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.doctor?.doctorName || ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 0 }}>
                <strong>Grouping</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }} colSpan={3}>
                : {getPatientGroupingDisplay({ patient: Patientdata?.patient }) || ""}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>

      {/* Insurance Details Section */}
      <div>
        <div className="py-2 px-3">
          <Typography fontSize={"1rem"} fontWeight={600} color={"primary"}>
            Insurance Details
          </Typography>
        </div>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell sx={{ border: 0 }}>
                <strong>Insurance Type</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.insurance?.insuranceType || ""}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>Insurance</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.insurance?.insurance || ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ border: 0 }}>
                <strong>Insurance Group</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.insurance?.insuranceGroup || ""}
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                <strong>Insurance Plan</strong>
              </TableCell>
              <TableCell sx={{ border: 0 }}>
                : {Patientdata?.insurance?.planName || ""}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default PatientDetails;
